export default __webpack_public_path__ + "static/media/our-process-teb-img-02.aee0da58.jpg";